<template>
    <contactinfo-tile @onsave="save" @isdirty="$emit('isdirty')" @isclean="$emit('isclean')" @oncancel="loadFromParent" 
                      :editmodel="editmodel" :parentmodel="origmodel" :tileicon="tileicon" :tile-header="tileheader" 
                      :tile-body="editmodel" :componenterr="componenterr" :savingdata="savingdata" 
                      :prioritizederrors="prioritizederrors" @inerrorstate="$emit('inerrorstate',arguments[0],arguments[1])"
                      :errorpriority="errorpriority" :parenterrorpriorities="parenterrorpriorities" :contentblocks="contentblocks">
        <template v-slot:component>

            <div class="form-group row">
                <div class="col-12">
                    <slot name="phonecontent"></slot>
                </div>
            </div>

            <forminput :id="phonetype" :label="tileheader" @onmodelchange="editmodel=arguments[0]"
                       @onmodelerror="componenterr=true" :maxlength="'24'" :placeholder="tileheader" :validations="['phonenumber']"
                       :editmodel="editmodel" :required="required" @onmodelvalid="componenterr=false"
                       :requiredmsg="'please enter a valid phone number'" :validationmsgs="contentblocks">
            </forminput>

        </template>
    </contactinfo-tile>
</template>

<script>
    import infotile from './tile.vue';
    import forminput from './forminput.vue';

    export default {
        name: 'phone-info',
        props: {
            parentmodel: {},
            tileicon: "",
            tileheader: "",
            phonetype: "",
            required: false,
            savingdata: false,
            prioritizederrors: Array,
            errorpriority: 0,
            parenterrorpriorities: Array,
            contentblocks: {}
        },
        components: {
            'contactinfo-tile': infotile,
            'forminput': forminput,
        },
        data: function () {
            return {
                errorModel: {},
                editmodel: {},
                onSave: this.save,
                componenterr: false,
                origmodel:"",
            }
        },
        created: function () {
            this.loadFromParent();
        },
        methods: {
            loadFromParent: function () {
                this.origmodel = this.parentmodel;
                if (!this.origmodel) {
                    this.origmodel = "";
                }
                this.editmodel = (' ' + this.origmodel).slice(1);
            },
            save: function () {
                this.$emit('onsave', this.editmodel, this.origmodel);
            },
        }
    }
</script>